import React from 'react';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';

import MyContractsTabs from 'components/MyContractsTabs';
import KnowMoreAboutContract from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import MyguaranteesBloc from 'containers/MyguaranteesBloc/index';
import DownloadFileAutoContracts from 'containers/AutoDetailsPage/MyContractsBloc/DownloadFileAutoContracts';
import MRHContractInfo from 'components/MyContractInfo/MRHContractInfo';
import { translate } from 'helpers/intl';
import {
  getIsLoadingContractDetailsMrhSelector,
  getContractsMrhSelector,
  getDetailsContractMrhSelector,
  getMrhGarantiesSelector,
  getMrhFilesSelector,
} from 'store/contract/selectors';
import { getDetailsContractMrh } from 'store/contract/actions';
import { CONTRACT_STATUSES } from 'utils/globalConst';
import messages from 'containers/AutoDetailsPage/messages';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const MyContractAndGarantiesTab = (props: {
  intl: IntlShape;
  contractsMRH: {
    name: string;
    adresse: string;
    contractNumber: string;
    status: string;
    effectDate: string;
    duration: string;
    product: string;
    deadline: string;
  }[];
  getDetailsContractMrh: Function;
  contractsDetailsMrh: string;
  garantiesMrh: [];
  filesMrh: [];
  isLoadingDetailContract: boolean;
}) => (
  <Grid container spacing={4}>
    <Grid item xs={12}>
      <KnowMoreAboutContract />
      <MyContractsTabs
        tabItems={
          props.contractsMRH &&
          props.contractsMRH.map(
            (item: {
              name: string;
              adresse: string;
              contractNumber: string;
              status: string;
              effectDate: string;
              duration: string;
              product: string;
              deadline: string;
            }) => ({
              label: item.adresse,
              contractNumber: item.contractNumber,
              circulationDate: 'item.circulationDate',
              content: (
                <MRHContractInfo
                  numPolice={item.contractNumber}
                  souscripteur={item.name}
                  dateDebut={item.effectDate}
                  dateFin={item.deadline}
                  primeMensuelle={
                    props.contractsDetailsMrh && props.contractsDetailsMrh
                  }
                  status={
                    item.status === CONTRACT_STATUSES.ACTIVE
                      ? 'success'
                      : 'error'
                  }
                  statusLabel={
                    item.status === CONTRACT_STATUSES.ACTIVE
                      ? translate({ ...messages.Actif }, props)
                      : translate({ ...messages.Encours }, props)
                  }
                />
              ),
            }),
          )
        }
        getDetailContract={props.getDetailsContractMrh}
        isLoadingDetailContract={props.isLoadingDetailContract}
        category=""
        label=""
      />
    </Grid>
    <Grid item xs={12}>
      <MyguaranteesBloc
        garanties={props.garantiesMrh}
        isLoadingDetailContract={props.isLoadingDetailContract}
      />
    </Grid>
    <Grid item xs={12}>
      <DownloadFileAutoContracts
        category={EVENT_CATEGORIES.MRH_DETAILS}
        files={props.filesMrh}
      />
    </Grid>
  </Grid>
);
const mapStateToProps = createStructuredSelector<
  any,
  {
    contractsMRH: [];
    garantiesMrh: [];
    filesMrh: [];
    contractsDetailsMrh: string;
    isLoadingDetailContract: boolean;
  }
>({
  contractsMRH: getContractsMrhSelector,
  contractsDetailsMrh: getDetailsContractMrhSelector,
  isLoadingDetailContract: getIsLoadingContractDetailsMrhSelector,
  garantiesMrh: getMrhGarantiesSelector,
  filesMrh: getMrhFilesSelector,
});
const mapDispatchToProps = {
  getDetailsContractMrh,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyContractAndGarantiesTab));
